import { ChangeDetectionStrategy, Component, computed, input, linkedSignal } from '@angular/core';

import { translate } from '@jsverse/transloco';

import { DialogService } from 'app/services/dialog.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Utils } from 'app/utils/utils';

export interface SnackbarData {
  id: string;
  message: string;
  duration: number;
  mode: 'default' | 'error';
  autoDismiss: boolean;
}

const DEFAULT_SNACKBAR_DATA: SnackbarData = {
  id: '',
  message: '',
  duration: 0,
  mode: 'default',
  autoDismiss: true,
};

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-xi-snack-bar',
  templateUrl: './lex-xi-snack-bar.component.html',
  styleUrls: ['./lex-xi-snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LexXiSnackBarComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly snackbarData = input<SnackbarData>(DEFAULT_SNACKBAR_DATA);
  readonly snackbarText = computed(() => {
    const data = this.snackbarData();
    if (this.isLongError(data)) {
      return `${Utils.truncate(data.message, 50)} <a id="detailsLink">Details</a>`;
    }
    return data.message;
  });
  readonly detailsText = computed(() => {
    const data = this.snackbarData();
    if (this.isLongError(data)) {
      return data.message;
    }
    return '';
  });

  readonly snackbarOpen = linkedSignal<SnackbarData, boolean>({
    source: this.snackbarData,
    computation: () => true,
  });

  private isLongError(data: SnackbarData): boolean {
    return data.mode === 'error' && data.message.length > 50;
  }

  constructor(private dialogService: DialogService) {}

  onSnackbarClicked($event) {
    if ($event.detail.target.id === 'detailsLink') {
      this.snackbarOpen.set(false);
      this.dialogService.showSimpleDialog({
        title: translate('lex-xi-snackbar-component.title'),
        content: this.detailsText(),
        confirmTitle: translate('lex-xi-snackbar-component.confirm'),
        disableCancel: true,
      });
    }
  }
}
